<template>
    <section class="flex min-h-[600px] flex-col gap-4">
        <div
            v-if="!review"
            class="flex flex-1 flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 bg-white p-8 text-center text-gray-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400"
        >
            <p class="text-sm font-medium">
                Selecione um saque na lista para iniciar a análise.
            </p>
        </div>

        <template v-else>
            <div class="relative">
                <div
                    v-if="actionProcessing"
                    class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/80 dark:bg-gray-800/80"
                >
                    <ticto-loading />
                </div>

                <div :class="['space-y-4', actionProcessing ? 'pointer-events-none opacity-50' : '']">
                    <smart-analysis
                        v-if="false"
                        ref="smartAnalysis"
                        :review="review"
                        :show-quick-actions="false"
                        @quick-approve="$emit('approve')"
                        @quick-reject="$emit('reject')"
                    />

                    <review-cashout
                        :cashout="review.cashout"
                        :review="review"
                        :payable-details="payableDetails"
                        @fetch="$emit('refresh', review)"
                    />

                    <review-summary-360
                        :review="review"
                        :is-same-day-urgent="isSameDayUrgent"
                    />

                    <cashout-checklist
                        v-if="review.cashout"
                        ref="cashoutChecklist"
                        :cashout-id="review.cashout.id"
                        :processing="actionProcessing"
                        @approve="$emit('approve')"
                        @reject="$emit('reject')"
                    />

                    <!-- <fraud-checklist
                        :items="checklist"
                        :completed-count="completedCount"
                        :disable-approve="actionProcessing || !isChecklistComplete"
                        :disable-reject="actionProcessing || !checklist.length"
                        :processing="actionProcessing"
                        @toggle="$emit('toggle-checklist', $event)"
                        @reset="$emit('reset-checklist')"
                        @approve="$emit('approve')"
                        @reject="$emit('reject')"
                    /> -->
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import SmartAnalysis from "./SmartAnalysis.vue";
import ReviewSummary360 from "./ReviewSummary360.vue";
import CashoutChecklist from "./CashoutChecklist.vue";
import FraudChecklist from "./FraudChecklist.vue";
import ReviewCashout from "./ReviewCashout.vue";
import TictoLoading from "../../layouts/TictoLoading.vue";

export default {
    name: "ReviewDecisionPanel",
    components: {
        SmartAnalysis,
        ReviewSummary360,
        CashoutChecklist,
        FraudChecklist,
        ReviewCashout,
        TictoLoading,
    },
    props: {
        review: {
            type: Object,
            default: null,
        },
        payableDetails: {
            type: Object,
            default: null,
        },
        checklist: {
            type: Array,
            default: () => [],
        },
        isChecklistComplete: {
            type: Boolean,
            default: false,
        },
        isSameDayUrgent: {
            type: Boolean,
            default: false,
        },
        actionProcessing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        completedCount() {
            return this.checklist.filter((item) => item.checked).length;
        },
    },
    methods: {
        // Expose forceReload method from SmartAnalysis component
        async reloadSmartAnalysis() {
            if (this.$refs.smartAnalysis && this.$refs.smartAnalysis.forceReload) {
                return await this.$refs.smartAnalysis.forceReload();
            }
        },
        // Reload the cashout checklist
        async reloadCashoutChecklist() {
            if (this.$refs.cashoutChecklist && this.$refs.cashoutChecklist.loadChecklist) {
                return await this.$refs.cashoutChecklist.loadChecklist();
            }
        }
    }
};
</script>
